/**
 *  Show an element if the organization is freemium
 */
;(function () {
  angular
    .module('contrast.freemium.directives')
    .directive('freemium', function (UserService, ORGANIZATION_SWITCH_EVENT) {
      'ngInject'

      return {
        link: function (scope, element) {
          function toggleVisibilityBasedOnFreemium() {
            var isFreemium = UserService.isFreemiumOrganization() || false
            if (isFreemium) {
              element.show()
            } else {
              element.hide()
            }
          }

          toggleVisibilityBasedOnFreemium()
          scope.$on(ORGANIZATION_SWITCH_EVENT, toggleVisibilityBasedOnFreemium)
        }
      }
    })
})()
